const TENDER_STATUSES = {
  active: 'active',
  finished: 'winner_selected',
  archived: 'archived',
};

export default TENDER_STATUSES;
